"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const convert = require('convert-units');
function convertStringPriceToNumber(input) {
    input = input.replace('$', '');
    let result = Number.parseFloat(input);
    if (Number.isNaN(result)) {
        return 0.00;
    }
    else {
        return result;
    }
}
function getGramsOfCarbonForPrice(input) {
    return input * 128.9;
}
function CarbonFootprint(props) {
    let price = convertStringPriceToNumber(props.price);
    let gramsOfCarbon = getGramsOfCarbonForPrice(price);
    let poundsOfCarbon = convert(gramsOfCarbon).from('g').to('lb');
    let bestUnit = convert(poundsOfCarbon).from('lb').toBest();
    return (react_1.default.createElement("div", { className: `row` },
        react_1.default.createElement("div", { className: 'col-6 d-flex' },
            react_1.default.createElement("h4", { className: 'align-self-center my-0' },
                react_1.default.createElement("a", { className: 'text-dark', target: "_blank", href: 'https://carbon-calculator.netlify.com' },
                    "CO",
                    react_1.default.createElement("sub", null, "2"),
                    " Calculator"))),
        react_1.default.createElement("div", { className: 'col-6' },
            react_1.default.createElement("div", { className: 'text-right' },
                react_1.default.createElement("small", { className: '' },
                    "Estimated CO",
                    react_1.default.createElement("sub", null, "2"),
                    "e Footprint"),
                react_1.default.createElement("h4", null,
                    bestUnit.val.toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2
                    }),
                    " ",
                    bestUnit.plural.toLowerCase())))));
}
exports.CarbonFootprint = CarbonFootprint;
//# sourceMappingURL=CarbonFootprint.js.map